import { ref, computed } from 'vue'

/**
 * Composable for managing the employee selection modal
 */
export function useEmployeeSelectorModal() {
  const showEmployeeModal = ref(false)
  const selectedProspect = ref(null)
  const selectedPreference = ref(null)
  const selectedPreferenceIndex = ref(null)

  function openEmployeeSelector(prospect, pref, prefIndex) {
    selectedProspect.value = prospect
    selectedPreference.value = pref
    selectedPreferenceIndex.value = prefIndex
    showEmployeeModal.value = true
  }

  function closeEmployeeModal() {
    showEmployeeModal.value = false
    selectedProspect.value = null
    selectedPreference.value = null
    selectedPreferenceIndex.value = null
  }

  function getInitialTeamId() {
    if (!selectedPreference.value) return ''
    const teams = selectedPreference.value.teams
    if (!teams) return ''
    const teamIds = Array.isArray(teams) ? teams : JSON.parse(teams || '[]')
    return teamIds[0] || ''
  }

  function getInitialFunction() {
    if (!selectedPreference.value) return ''
    const levels = selectedPreference.value.experience_levels
    if (!levels) return ''
    const experienceLevels = Array.isArray(levels) ? levels : JSON.parse(levels || '[]')
    return experienceLevels[0] || ''
  }

  function getInitialDpw() {
    if (!selectedPreference.value) return 1.0
    return parseFloat(selectedPreference.value.dpw) || 1.0
  }

  function getPreferencePeriodStart() {
    if (!selectedPreference.value && !selectedProspect.value) return null
    return selectedPreference.value?.start_date || selectedProspect.value?.start_date || null
  }

  function getPreferencePeriodEnd() {
    if (!selectedPreference.value && !selectedProspect.value) return null
    return (
      selectedPreference.value?.end_date || selectedProspect.value?.expected_closing_date || null
    )
  }

  const employeeModalProps = computed(() => ({
    open: showEmployeeModal.value,
    project: selectedProspect.value || {},
    initialTeamId: getInitialTeamId(),
    initialFunction: getInitialFunction(),
    initialDpw: getInitialDpw(),
    periodStart: getPreferencePeriodStart(),
    periodEnd: getPreferencePeriodEnd()
  }))

  return {
    showEmployeeModal,
    selectedProspect,
    selectedPreference,
    selectedPreferenceIndex,
    openEmployeeSelector,
    closeEmployeeModal,
    getInitialTeamId,
    getInitialFunction,
    getInitialDpw,
    getPreferencePeriodStart,
    getPreferencePeriodEnd,
    employeeModalProps
  }
}
